import { Route } from "@angular/router";
import { PainelMinhasIndicacoesPage } from "./painel-minhas-indicacoes.page";

export const PainelMinhasIndicacoesRouter: Route[] = [
  { path: 'painel-minhas-indicacoes', component: PainelMinhasIndicacoesPage }
];
